export default __webpack_public_path__ + "static/media/solicitud.9c205f71.png";